import React from "react";
import tw from "twin.macro";
import LineChart from "../charts/LineChart";
import mechanic from "../../data/mechanic";
import applicationDevelopment from "../../data/applicationDevelopment";
import ictSysteme from "../../data/ictSysteme";
import ictNetwork from "../../data/ictNetwork";



const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;

const mechanicData = {
    label: "",
    data: mechanic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const applicationDevelopmentData = {
    label: "",
    data: applicationDevelopment,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictSystemeData = {
    label: "",
    data: ictSysteme,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictNetworkData = {
    label: "",
    data: ictNetwork,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    d3 = "",
                    d4 = "",
                    image1="",
                    ex1="",
                    ex2=""
                }) => {
    return (
        <>
            <h1>{title}</h1>
            <h6><strong>{ex1}</strong></h6>
            <p>
                {d1}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[mechanicData]}
                        title="Mechanic / EFZ mechanical engineering"
                        legend={false}
                        dateFormat="month"
                    />
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d2}
            </p>
            <h6><strong>{ex2}</strong></h6>
            <p>
                {d3}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[applicationDevelopmentData]}
                        title="Application development"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[ictSystemeData]}
                        title="ICT Systeme, Infrastructure"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[ictNetworkData]}
                        title="ICT networks"
                        legend={false}
                        dateFormat="month"
                    />
                </ImageColumn>
            </div>
            <p>
                {d4}
            </p>


        </>
    );
};
